var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa fa-sign-out logoutButton",attrs:{"title":_vm.$t('core.header.logout'),"aria-hidden":"true"},on:{"click":_vm.logout}})}
var staticRenderFns = []

export { render, staticRenderFns }